import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=7d495606&scoped=true&"
import script from "./Overlay.vue?vue&type=script&lang=js&"
export * from "./Overlay.vue?vue&type=script&lang=js&"
import style0 from "./overlay.scss?vue&type=style&index=0&id=7d495606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d495606",
  null
  
)

export default component.exports